import React from 'react';

function BrandMark({ size = 42, className = '' }) {
  return (
    <svg
      className={`mark ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M20 2.5l15 8.66v17.32L20 37.5 5 28.48V11.16L20 2.5z"
        fill="#F3ECC4"
        stroke="rgba(0,0,0,0.10)"
        strokeWidth="1"
      />
      <path
        d="M14 27V13h2.6l7 9.4V13h2.6v14h-2.6l-7-9.4V27H14z"
        fill="#1B241F"
      />
    </svg>
  );
}

export default BrandMark;
